const wishlistInit = (wishlist: HTMLElement) => {
  const miniFavorite = document.querySelector('.mini-favorites') as HTMLElement;
  const closeFavorite = miniFavorite.querySelectorAll('.widget-title, .mini-favorites__overlay') as NodeListOf<HTMLElement>;

  const toggleFavorite = () => {
    miniFavorite.classList.toggle('mini-favorites--active');
  };

  [...closeFavorite].forEach((item) => {
    item.addEventListener('click', () => {
      toggleFavorite();
    });
  });

  wishlist.addEventListener('click', () => {
    toggleFavorite();
  });
};

export default wishlistInit;
